let URL = `https://pokeapi.co/api/v2/pokemon?offset=0&limit=30`;
export const getPokemons = (x) => {
  return fetch(`https://pokeapi.co/api/v2/pokemon?offset=0&limit=${x}`).then(
    (response) => response.json()
  );
};

export const getPokemon = (x) => {
  return fetch(`https://pokeapi.co/api/v2/pokemon?offset=${x}&limit=911`).then(
    (response) => response.json()
  );
};
